import { useEffect } from "react";
import { bool, node, string } from "prop-types";
import { observer } from "mobx-react";
import { APP_CONTAINER, CELL_HEIGHTS } from "@utils";
import { useStores, useContainerScrollHandler, useResizeObserver } from "@hooks";
import { makeStyles } from "@material-ui/styles"
import { APP_BAR_HEIGHTS } from "@styles/themes";
import classnames from "classnames";


export const AppContainer = observer(({
  children,
  isPdfPrinterView,
  useViewportResizeObserver,
  className
}) => {

  const classes = useStyle();
  const { stateStore } = useStores();

  const handleScroll = useContainerScrollHandler();

  // Apply global styles for print view
  useEffect(() => {
    if (isPdfPrinterView) {
      const body = document.body;
      // const root = document.getElementById('root');

      // Add class to body for print view
      body.classList.add('print-view-active');

      // Cleanup on unmount
      return () => {
        body.classList.remove('print-view-active');
      };
    }
  }, [isPdfPrinterView]);

  const handleViewPortChange = () => {
    document.querySelector(
      'meta[name="viewport"]'
    ).content = `width=device-width, initial-scale=${Math.min(
      window.screen.width / CONTENT_WIDTH,
      1
    )}`;
  };

  useResizeObserver(handleViewPortChange, stateStore.scrollRef, !useViewportResizeObserver);

  return (
    <div
      id={ APP_CONTAINER }
      ref={stateStore.setScrollRef}
      className={classnames(classes.root, isPdfPrinterView && classes.printView, className)}
      onScroll={!isPdfPrinterView ? handleScroll : undefined}
      data-print-view={isPdfPrinterView ? "true" : undefined}
      // style={isPdfPrinterView ? { height: 'auto', overflow: 'visible', minHeight: '100vh' } : undefined}
    >
      {children}
    </div>
  )
});

AppContainer.propTypes = {
  children: node,
  noScroll: bool,
  isPdfPrinterView: bool,
  useViewportResizeObserver: bool,
  className: string
}

const useStyle = makeStyles(() => ({
  root: {
    width: "100%",
    height: `calc(100% - ${APP_BAR_HEIGHTS.SMALL}px)`,
    display: "block",
    overflow: "auto",
    overflowAnchor: "none",
    scrollPaddingTop: `${CELL_HEIGHTS.XSMALL + 8}px`,
    scrollPaddingBottom: "8px",
    "@media (min-width: 600px)": {
      height: `calc(100% - ${APP_BAR_HEIGHTS.LARGE}px)`,
    }
  },
  printView: {
    height: "auto !important",
    overflow: "visible !important",
    minHeight: "100vh"
  }
}));